<template>
  <div class="subsector-filter" ref="root">
    <button type="button" class="filter-toggle" @click="open = !open">
      Subsectors
      <span v-if="excludedSubsectors.length" class="filter-badge">{{ excludedSubsectors.length }} hidden</span>
      <span class="filter-caret" :class="{ 'is-open': open }">▾</span>
    </button>

    <div v-if="open" class="filter-dropdown">
      <div class="filter-actions">
        <button type="button" class="filter-action-btn" @click="$emit('show-all')">Show all</button>
        <button type="button" class="filter-action-btn" @click="$emit('hide-all')">Hide all</button>
      </div>

      <div v-if="!availableSubsectors.length" class="filter-empty">No subsectors available.</div>

      <label v-for="s in availableSubsectors" :key="s" class="filter-item">
        <input
          type="checkbox"
          :checked="!excludedSubsectors.includes(s)"
          @change="$emit('toggle', s)"
        />
        <span>{{ s }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubsectorFilter',

  props: {
    availableSubsectors: { type: Array, default: () => [] },
    excludedSubsectors:  { type: Array, default: () => [] },
  },

  emits: ['toggle', 'show-all', 'hide-all'],

  data() {
    return { open: false }
  },

  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside)
  },

  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  },

  methods: {
    handleClickOutside(e) {
      if (this.open && this.$refs.root && !this.$refs.root.contains(e.target)) {
        this.open = false
      }
    },
  },
}
</script>

<style scoped>
.subsector-filter {
  position: relative;
}

.filter-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: #fff;
  color: #003366;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.15s;
}
.filter-toggle:hover { border-color: #4da6ff; }

.filter-badge {
  background: #4da6ff;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 10px;
}

.filter-caret {
  font-size: 10px;
  color: #9ca3af;
  transition: transform 0.15s;
}
.filter-caret.is-open { transform: rotate(180deg); }

.filter-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 240px;
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 51, 102, 0.12);
  padding: 10px;
  z-index: 20;
}

.filter-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.filter-action-btn {
  flex: 1;
  padding: 5px 8px;
  background: #f3f4f6;
  color: #003366;
  border: none;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.filter-action-btn:hover { background: #dbeafe; }

.filter-empty {
  font-size: 12px;
  color: #9ca3af;
  padding: 8px 4px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 4px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  border-radius: 4px;
}
.filter-item:hover { background: #f9fafb; }

.filter-item input[type="checkbox"] {
  accent-color: #003366;
  width: 14px;
  height: 14px;
  cursor: pointer;
}
</style>
